import React from 'react';

import {
  SectionHeader,
  StyledTable,
  TabSection,
} from './_shared';

function Documents() {
  return (
    <TabSection>
      <SectionHeader title={<span>TABLEAU RÉCAPITULATIF – DOCUMENTS UTILES SELON LE PROJET</span>} />
      <p>
        Voici un tableau synthétique que le Référent Mutation Location pourra utiliser comme support lors de ses appels. Il permet de répondre rapidement à la question : « Quels documents vais-je devoir fournir selon que je vends ou que je loue ? »
      </p>

      <StyledTable>
        <thead>
          <tr>
            <th style={{ background: '#2c3e50', color: 'white', padding: '15px', textAlign: 'left', fontWeight: 600 }}>Contexte</th>
            <th style={{ background: '#2c3e50', color: 'white', padding: '15px', textAlign: 'left', fontWeight: 600 }}>Documents à fournir</th>
            <th style={{ background: '#2c3e50', color: 'white', padding: '15px', textAlign: 'left', fontWeight: 600 }}>Commentaires / Intérêt</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ background: 'white' }}>
            <td style={{ padding: '15px', borderBottom: '1px solid #e9ecef' }}><strong>VENTE</strong></td>
            <td style={{ padding: '15px', borderBottom: '1px solid #e9ecef' }}>
              - Carnet d'entretien de l'immeuble<br />
              - Règlement de copropriété<br />
              - État daté (obligatoire)<br />
              - Pré-état daté (recommandé)<br />
              - Procès-verbaux des 3 dernières AG<br />
              - Appels de charges et relevés de compteurs<br />
              - Diagnostics techniques du lot (DPE, amiante, plomb, électricité, gaz, ERP, loi Carrez…)<br />
              - Diagnostics des parties communes (si existants)<br />
              - Rapport des ventes récentes dans l'immeuble
            </td>
            <td style={{ padding: '15px', borderBottom: '1px solid #e9ecef' }}>
              - L'état daté doit être fourni par le syndic avant l'acte définitif.<br />
              - Le pré-état daté, bien que non obligatoire, sécurise la transaction et évite les retards.<br />
              - Les autres documents anticipent les demandes du notaire et de l'acquéreur.
            </td>
          </tr>
          <tr style={{ background: 'white' }}>
            <td style={{ padding: '15px', borderBottom: '1px solid #e9ecef' }}><strong>LOCATION</strong></td>
            <td style={{ padding: '15px', borderBottom: '1px solid #e9ecef' }}>
              - Dossier de diagnostic technique (DPE, amiante si construit avant 1997, électricité/gaz si &gt; 15 ans, ERP…)<br />
              - Règlement de copropriété (extraits relatifs à l'usage du lot)<br />
              - Carnet d'entretien de l'immeuble<br />
              - Surface habitable (loi Boutin)<br />
              - Relevés de charges locatives récupérables<br />
              - Éventuels diagnostics complémentaires (plomb, si logement ancien)
            </td>
            <td style={{ padding: '15px', borderBottom: '1px solid #e9ecef' }}>
              - Le dossier doit être complet avant la signature du bail.<br />
              - Le règlement de copropriété est utile pour informer le locataire (usage des parties communes, travaux, etc.).<br />
              - Les charges récupérables doivent être justifiées par le syndic.
            </td>
          </tr>
        </tbody>
      </StyledTable>
    </TabSection>
  );
}

export default Documents;


